// common
import React, { useEffect, useState } from "react";

// redux
import { connect } from "react-redux";
import { mapDispatchProps, mapStateToProps } from "../../store/store";

// components
import Button from "../button";
import clsx from "clsx";
import { useForceUpdate } from "../../hooks/useForceUpdate";
import { useLanguage } from '@languages/index';


// Props Interface
interface Props {
  className?: any;
  style?: any;

  notification?: any;
  setNotification?: any;
  preferences?: any;
  setPreferences?: any;
}

const NotificationContainer: React.FunctionComponent<Props> = (
  props: Props
) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.component.notification };

  const forceUpdate = useForceUpdate();
  const [opened, setIsOpened] = useState(undefined);
  const fadeOutDuration = 300;

  useEffect(() => {
    if (props.notification.isVisible) {
      setIsOpened(true);
    }
  }, [props.notification]);

  useEffect(() => {
    forceUpdate();
  }, [props.preferences.headerHeight]);

  useEffect(() => {
    if (props.notification.closeNotification) {
      setTimeout(() => {
        props.setNotification({ isVisible: false });
      }, fadeOutDuration);
    }
  }, [props.notification]);

  if (!props.notification.isVisible) {
    return <></>;
  }

  const closeNotification = () => {
    if (props.notification.onRequestClose) {
      props.notification.onRequestClose();
    }

    if (props.notification.preventClose) {
      return false;
    }

    // fadeOut();

    setTimeout(() => {
      props.setNotification({ isVisible: false });
    }, fadeOutDuration);
  };

  const renderCustomNotification = () => {
    if (!props.notification.content) {
      return null;
    }

    return props.notification.content();
  };

  const renderDefaultNotification = () => {
    if (props.notification.content) {
      return null;
    }

    const onConfirm = () => {
      if (props.notification.confirm) {
        props.notification.confirm();
      }

      closeNotification();
    };

    const onCancel = () => {
      if (props.notification.cancel) {
        props.notification.cancel();
      }

      closeNotification();
    };

    const renderTitle = () => {
      if (!props.notification.title) {
        return null;
      }

      return (
        <span className="prose prose-xl text-black">
          {props.notification.title}
        </span>
      );
    };

    const renderText = () => {
      return (
        <span
          className="prose prose-md text-black"
          style={{ whiteSpace: "pre-wrap" }}
        >
          {props.notification.text}
        </span>
      );
    };

    const windowBackgroundColor = "white";

    const renderNotificationWindow = () => {
      return (
        <div
          className="flex flex-col justify-center align-center p-5"
          style={{ backgroundColor: windowBackgroundColor }}
        >
          <div className="content flex flex-col">
            {renderTitle()}
            {renderText()}
          </div>
          <div className="buttons flex flex-row columns-2 mt-4 gap-1.5">
            {props.notification.cancel ? (
              <Button text={languageTexts.cancel} onClick={() => onCancel()} />
            ) : null}
            {!props.notification.hideConfirmButton ? (
              <Button text={languageTexts.confirm} onClick={() => onConfirm()} />
            ) : null}
          </div>
        </div>
      );
    };

    return renderNotificationWindow();
  };

  const defaultClassNames = props.notification.className
    ? "notification mt-2 cursor-pointer" + props.notification.className
    : "notification mt-2 cursor-pointer max-w-lg";
  return (
    <div
      className={`notification-container flex flex-col z-[1]`}
      style={{
        marginTop: props.preferences.headerHeight
          ? `${props.preferences.headerHeight}px`
          : "68px",
      }}
    >
      <div
        className={clsx(
          defaultClassNames,
          "animate__animated animate__slideInDown"
        )}
        style={{
          ...{ maxHeight: "70dvh", maxWidth: "100vw" },
        }}
      >
        {renderCustomNotification()}
        {renderDefaultNotification()}
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchProps
)(NotificationContainer);
